import { AccessorsMutatorsDecorator, Model } from '../../helpers';
import { Property } from './property.model';
import { BillingPaymentOption } from "./billing-payment-option.model";

/**
 * @class BillingTransaction
 *
 * @property id
 * @property property_id
 * @property billing_invoice_id
 * @property billing_invoice
 * @property property
 * @property is_refund
 * @property amount
 * @property status
 * @property failure
 * @property payment_method
 * @property cheque_number
 * @property bank
 * @property ref_number
 * @property date
 * @property memo
 * @property created_at
 * @property user_name
 * @property refund_ident
 * @property transaction_id
 * @property can_refunded
 * @property overpaid
 */
export class BillingTransaction extends Model {

    static get ACTION_PAYMENT() {

        return 0;
    }

    static get ACTION_REFUND() {

        return 1;
    }

    static get ACTIONS() {

        return [
            this.ACTION_PAYMENT,
            this.ACTION_REFUND,
        ];
    }

    static get FORMATTED_ACTIONS() {

        return {
            [this.ACTION_PAYMENT]: 'PAYMENT',
            [this.ACTION_REFUND]: 'REFUND',
        }
    }

    static get TYPE_ONLINE() {

        return 1;
    }

    static get TYPE_OFFLINE() {

        return 2;
    }

    static get FORMATTED_TYPE() {

        return {
            [this.TYPE_ONLINE]: 'ONLINE',
            [this.TYPE_OFFLINE]: 'OFFLINE',
        }
    }

    static get PENDING_STATUS() {

        return 0;
    }

    static get PAID_STATUS() {

        return 1;
    }

    static get FAIL_STATUS() {

        return 2;
    }

    static get STATUSES() {

        return [
            this.PENDING_STATUS,
            this.PAID_STATUS,
            this.FAIL_STATUS,
        ];
    }

    static get FORMATTED_STATUSES() {

        return {
            [this.PENDING_STATUS]: 'PENDING',
            [this.PAID_STATUS]: 'SUCCESS',
            [this.FAIL_STATUS]: 'FAIL',
        }
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

    isManual() {

        return [
            BillingPaymentOption.CASH.id,
            BillingPaymentOption.CHEQUE.id,
            BillingPaymentOption.POS.id,
            BillingPaymentOption.BANK_TRANSFER.id,
        ].includes(this.payment_method);
    }

    formatIsRefund() {

        return this.constructor.FORMATTED_ACTIONS[this.is_refund];
    }

    formatStatus() {

        return this.constructor.FORMATTED_STATUSES[this.status];
    }

    formatType() {

        return this.constructor.FORMATTED_TYPE[this.type];
    }

    formatPaymentMethod() {

        return BillingPaymentOption.ALL_PAYMENT_OPTIONS.find(option => option.id === +this.payment_method).label;
    }

    showDescriptionAddedInvoice() {

        return this.isManual() ? 'PAYMENT_WAS_ADDED_TO_INVOICE_ID' : 'AUTOPAYMENT_HAS_BEEN_ADDED_TO_INVOICE_ID';
    }

    showDescriptionByUser() {

        return this.isManual() ? 'BY_USER_NAME_CONFIRMED' : '';
    }

    isPaid() {

        return this.status === this.constructor.PAID_STATUS;
    }

    setAmount(value = 0) {

        if (!value) {

            return 0;
        }

        return parseFloat(value);
    }
}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'billing_invoice_id',
    'billing_invoice',
    'property',
    'is_refund',
    'amount',
    'status',
    'failure',
    'payment_method',
    'cheque_number',
    'bank',
    'ref_number',
    'date',
    'memo',
    'created_at',
    'user_name',
    'refund_ident',
    'transaction_id',
    'can_refunded',
    'overpaid',
    'ident',
    'property_name',
    'email',
    'type',
    'last_digit',
    'gateway_transaction_id',
    'payment',
    'invoice_total',
    'transaction_amount',
    'attachment',
    'calc_balance',
    'due_date',
    'is_sms_type',
    'is_shomoos_type',
)(BillingTransaction);



// WEBPACK FOOTER //
// ./src/pms-api/models/billing-transaction.model.js